import * as React from "react";
import {Fade, styled, SvgIcon, Tooltip, tooltipClasses} from "@mui/material";


//export const domain = 'http://127.0.0.1:8000/'
//export const domain = 'http://8.130.17.44:8006/'
export const domain = 'https://wantquotes.net/api/'
//export const ws_domain = 'wss://wantquotes.net/ws/'

export function toast(msg, duration, callback) {
    duration = isNaN(duration) ? 500 : duration;
    let m = document.createElement('div');
    m.innerHTML = msg;
    m.style.cssText = "max-width:13em;min-width: 13em;padding:0 14px;height: 40px;color: rgb(255, 255, 255);line-height: 40px;text-align: center;border-radius: 4px;position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index: 999999;background: rgba(0, 0, 0,.7);font-size: 16px;";
    document.body.appendChild(m);
    setTimeout(function () {
        let d = 0.5;
        m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
        m.style.opacity = '0';
        setTimeout(function () {
            document.body.removeChild(m);
            if (callback !== undefined) callback();
        }, d * 1000);
    }, duration);
}

export const LightTooltip = styled(({className, ...props}) => (
    <Tooltip {...props} classes={{popper: className}} TransitionComponent={Fade}/>
))(({theme}) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 14,
        fontFamily: '楷体, STKaiti, serif'
    },
}));

export function DefIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 1024 1024">
            <path
                d="M865.426286 0A158.756571 158.756571 0 0 1 1024 158.573714v706.852572A158.756571 158.756571 0 0 1 865.426286 1024H158.573714A158.756571 158.756571 0 0 1 0 865.426286V158.573714A158.756571 158.756571 0 0 1 158.573714 0z m0 81.152H158.573714A77.531429 77.531429 0 0 0 81.188571 158.573714v706.852572a77.531429 77.531429 0 0 0 77.421715 77.421714h706.852571a77.531429 77.531429 0 0 0 77.458286-77.421714V158.573714a77.531429 77.531429 0 0 0-77.458286-77.421714z m-219.465143 423.021714v49.115429h161.097143v70.582857h-161.097143v66.267429h169.947428v70.875428h-169.947428v45.714286l-68.498286-0.036572v-45.714285h-169.984V690.102857h169.874286v-66.267428h-162.742857V553.325714h162.852571v-49.115428h68.498286z m-391.533714-125.074285c23.844571 0 41.618286 6.107429 52.882285 18.176 10.459429 11.264 15.725714 28.781714 15.725715 52.114285v260.900572c0 15.725714 2.194286 20.297143 3.547428 21.650285 1.974857 2.084571 7.021714 4.498286 20.187429 4.498286h35.401143v68.498286H328.96c-22.930286 0-38.4-3.072-47.104-9.325714-18.066286-13.421714-27.245714-32-27.245714-55.222858v-264.338285c0-17.188571-3.547429-23.259429-6.546286-25.344-1.828571-1.316571-6.326857-2.889143-17.700571-2.889143H190.390857v-2.925714h-2.925714v-65.792h66.962286z m467.419428-149.76c34.742857 0 59.501714 5.851429 73.837714 17.481142l3.364572 3.035429c10.24 9.874286 15.945143 23.478857 15.798857 37.668571 0 25.380571-11.812571 51.638857-34.889143 78.043429-12.836571 14.628571-33.645714 31.926857-63.451428 52.772571 35.437714 9.874286 67.218286 17.700571 97.024 23.954286l2.340571 0.512v70.802286l-3.730286-0.877714c-35.693714-9.142857-96.841143-25.819429-186.843428-50.870858-67.035429 18.029714-139.849143 35.108571-216.576 50.688l-3.510857 0.731429v-70.582857l52.370285-12.068572 53.942857-12.507428c-23.881143-13.897143-42.130286-26.331429-55.552-37.851429-12.470857-10.715429-29.330286-28.013714-50.029714-51.346285l-4.388571-4.900572h97.389714l0.841143 0.731429a362.313143 362.313143 0 0 0 110.628571 64.731428c34.852571-14.665143 62.537143-29.513143 82.212572-44.251428 19.858286-14.774857 30.866286-27.062857 32.694857-36.790857l0.256-2.816a7.387429 7.387429 0 0 0-3.693714-6.619429c-0.329143-0.182857-2.925714-1.170286-17.078858-1.170286H405.211429V229.302857h316.708571zM332.507429 229.12v68.498286H187.465143V229.12h145.042286z"
            />
        </SvgIcon>
    );
}

export default function TriggersTooltips(props) {
    const hoverOpen = props.hoverOpen || false;
    const [open, setOpen] = React.useState(false);
    const HtmlTooltip = styled(({className, ...props}) => (
        <Tooltip {...props} classes={{popper: className}}/>
    ))(({theme}) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#ffffff',
            color: 'rgba(0, 0, 0, 1)',
            maxWidth: 600,
            fontSize: 12,
            border: hoverOpen?'3px solid #dadde9' :'1px solid #dadde9',
            //marginBottom: '2px !important'
        },
        [`& .${tooltipClasses.arrow}`]: {
            "&::before": {
                backgroundColor: "#ffffff",
                border: "1px solid #c7c7c7",
            },
        }
    }));
    return (
        <HtmlTooltip
            PopperProps={{
                disablePortal: true,
            }}
            onClose={() => {
                setOpen(false);
            }}
            open={open}

            title={
                props.tip
            }
            placement={props.placement}
            disableFocusListener
            arrow
            onClick={() => {
                setOpen(true);
            }}
            onMouseEnter={()=>{
                if(hoverOpen) setOpen(true)
            }}
        >
            {props.trigger}
        </HtmlTooltip>
    );
}

export function forceRedraw(element){

    if (!element) { return; }

    let n = document.createTextNode(' ');
    let disp = element.style.display;  // don't worry about previous display style

    element.appendChild(n);
    element.style.display = 'none';

    setTimeout(function(){
        element.style.display = disp;
        n.parentNode.removeChild(n);
    },20); // you can play with this timeout to make it as short as possible
}

export function isMobile() {
    return !!window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
}